import { forwardRef, useImperativeHandle } from 'react';
import { isEppDeviceBasketItem } from '../../utils/placeOrderUtilsCoCo.js';
import { ContactOrPurposeSectionCoCo } from '../shared/ContactOrPurposeSectionCoCo.js';
import { DeviceEnrollmentProgramSectionCoCo } from './DeviceEnrollmentProgramSectionCoCo.js';
import type { ConfigHandle, ProductConfigProps } from '../productConfigTypesCoCo.js';

export const DeviceProductConfigCoCo = forwardRef<ConfigHandle, ProductConfigProps>(
  ({ basketItem, orderItem, schema, contactFormRefs, contactsUpdateMethods }, ref) => {
    const cartItemInstanceId = `${basketItem.id}-${orderItem.basketItemIndex}`;

    // The user or purpose of use is only mandatory for EPP devices; purchased devices are optional.
    const isEppDevice = isEppDeviceBasketItem(basketItem);

    // DeviceProductConfigCoCo has no inner form — the contact form ref handles all validation
    // by being collected into contactFormRefs in ProductsStepCoCo.
    useImperativeHandle(
      ref,
      () => ({
        validate: async () => true,
        scrollToFirstError: () => {},
        getErrorCount: () => 0,
      }),
      []
    );

    return (
      <div id={`device-config-${cartItemInstanceId}`}>
        <ContactOrPurposeSectionCoCo
          schema={schema}
          orderItem={orderItem}
          contactFormRefs={contactFormRefs}
          contactsUpdateMethods={contactsUpdateMethods}
          isMandatory={isEppDevice}
          showAccordion={true}
          defaultExpanded={isEppDevice}
          showUserContact={true}
        />
        <DeviceEnrollmentProgramSectionCoCo basketItem={basketItem} orderItem={orderItem} />
      </div>
    );
  }
);

DeviceProductConfigCoCo.displayName = 'DeviceProductConfigCoCo';
